/**
 * list of custom events,
 */
export const EVENT_KEYS = {
  // org
  ORG_AUTHORIZATION_CHANGE: 'org-authorization-change',

  // db
  DB_OPENED: 'db-opened',
  DB_TABLE_DATA_LOADED: 'db-table-data-loaded',
  SNAPSHOT_ALERT_MODAL: 'snapshot-alert-modal',
  DB_CLIENT_RELOAD: 'db-client-reload',
  DB_CLIENT_UPDATED: 'db-client-updated',
  DB_TABLE_CREATED: 'db-table-created',
  DB_TABLE_DUPLICATED: 'db-table-duplicated',
  DB_TABLE_DELETED: 'db-table-deleted',
  DB_TABLE_ROWS_UPDATED: 'db-table-rows-updated',

  // project
  GLOBAL_APP_LOADING: 'global-app-loading',
  APP_BUILDER_LOADING: 'app-builder-loading',
  APP_BUILDER_LOADED: 'app-builder-loaded',
  OVERLAY_CLOSE: 'overlay-close',
  UPDATE_GLOBAL_VARIABLES: 'update-global-variables',
  APP_AUTH_USER_TABLE_UPDATED: 'app-auth-user-table-updated',
  APP_CLIENT_RELOAD: 'app-client-reload',
  RECENT_APPS_UPDATED: 'recent-apps-updated',

  // builder
  OPEN_VERSION_HISTORY: 'open-version-history',
  APP_BUILDER_RELOAD: 'app-builder-reload',
  RELOAD_PREVIEW_FRAME: 'reload-preview-frame',
  BUILDER_FORM_RESET: 'builder-form-reset',
  BUILDER_FORM_RESET_HIDDEN_FIELD: 'builder-form-reset-hidden-field',
  BUILDER_SCROLL_TOP: 'builder-scroll-top',
  COMP_OPEN_SETTINGS: 'comp-open-settings',
  PAGE_PROCESS_FINISHED: 'page-process-finished',
  APP_PREVIEW_LOADED: 'app-preview-loaded',
  APP_BUILDER_UNDO_REDO_FINISHED: 'app-builder-undo-redo-finished',

  // grid
  GRID_SEARCH_TOGGLE: 'grid-search-toggle',
}
